


















































































import Vue from "vue";
import { mapActions, mapState, mapGetters } from "vuex";
import iwSectionWithIcon from "@/encoding/components/layout/SectionWithIcon.vue";
import iwPlanningPermission from "@/encoding/pages/questions/regulations/PlanningPermission.vue";
import iwAsBuiltPlan from "@/encoding/pages/questions/regulations/AsBuiltPlan.vue";
import iwSubdivisionPermit from "@/encoding/pages/questions/regulations/SubdivisionPermit.vue";
import iwPriorityPurchase from "@/encoding/pages/questions/regulations/PriorityPurchase.vue";
import iwBreachingUrbanPlanningRegulation
    from "@/encoding/pages/questions/regulations/BreachingUrbanPlanningRegulation.vue";
import iwLandDesignation from "@/encoding/pages/questions/regulations/LandDesignation.vue";
import iwTownPlanning from "@/encoding/pages/questions/regulations/TownPlanning.vue";
import iwFloodZone from "@/encoding/pages/questions/regulations/FloodZone.vue";
import iwFloodSensitivityProperty from "@/encoding/pages/questions/regulations/FloodSensitivityProperty.vue";
import iwFloodSensitivityBuilding from "@/encoding/pages/questions/regulations/FloodSensitivityBuilding.vue";
import iwConstructionType from "@/encoding/pages/questions/regulations/ConstructionType.vue";
import iwTotalGroundFloorBuildable from "@/encoding/pages/questions/regulations/TotalBuildableGroundFloorSurface.vue";
import iwObligationToBuild from "@/encoding/pages/questions/regulations/ObligationToBuild.vue";
import iwAsbestosCertificateAvailable from "@/encoding/pages/questions/regulations/AsbestosCertificateAvailable.vue";
import iwEnforcementMeasuresRegisterConsulted from "@/encoding/pages/questions/regulations/EnforcementMeasuresRegisterConsulted.vue";
import iwNextPreviousButton from "@/encoding/components/NextPreviousButton.vue";
import { isPropertyInFlanders, updateClassified, validationClassified } from "@/shared/scripts/ValidateData";
import { getFloodInfoRegion, floodInfoLink } from "@/shared/scripts/helpers/regulations/floodInfoLinks.data";
import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";
import { ACCEPTABLE_PROPERTY_TYPES } from "@/shared/scripts/helpers/constants/propertyTypes";

export default Vue.extend({
    components: {
        iwSectionWithIcon: iwSectionWithIcon,
        iwPlanningPermission: iwPlanningPermission,
        iwAsBuiltPlan: iwAsBuiltPlan,
        iwSubdivisionPermit: iwSubdivisionPermit,
        iwPriorityPurchase: iwPriorityPurchase,
        iwBreachingUrbanPlanningRegulation: iwBreachingUrbanPlanningRegulation,
        iwObligationToBuild: iwObligationToBuild,
        iwAsbestosCertificateAvailable: iwAsbestosCertificateAvailable,
        iwEnforcementMeasuresRegisterConsulted: iwEnforcementMeasuresRegisterConsulted,
        iwFloodZone: iwFloodZone,
        iwFloodSensitivityProperty: iwFloodSensitivityProperty,
        iwFloodSensitivityBuilding: iwFloodSensitivityBuilding,
        iwConstructionType: iwConstructionType,
        iwLandDesignation: iwLandDesignation,
        iwTotalGroundFloorBuildable: iwTotalGroundFloorBuildable,
        iwTownPlanning: iwTownPlanning,
        iwNextPreviousButton: iwNextPreviousButton,
    },

    data: function() {
        return {
            isButtonDisabled: false,
        };
    },

    computed: {
        ...mapGetters({
            getValue: "FormModule/getValue",
            classifiedId: "FormModule/getClassifiedId",
        }),
        ...mapState("FormModule", ["isEditionMode"]),
        moreRegionalInformation: function(): string {
            return this.$t("more_info_planning_building_regulations") as string;
        },
        addressPostalCode: function(): string {
            return this.getValue("property.location.address.postalCode");
        },
        addressCountry: function(): string {
            return this.getValue("property.location.address.country");
        },
        propertyType: function(): string {
            return this.getValue("property.type");
        },
        transactionType: function(): string {
            return this.getValue("transaction.type");
        },
        renderEnforcementMeasuresRegisterConsulted: function(): boolean {
            return (
                this.classifiedId !== null &&
                ACCEPTABLE_PROPERTY_TYPES.includes(this.propertyType) &&
                this.transactionType === "FOR_SALE" &&
                isPropertyInFlanders(this.addressCountry, this.addressPostalCode)
            );
        },
        renderAsbestosCertificateAvailable: function(): boolean {
            return (
                ACCEPTABLE_PROPERTY_TYPES.includes(this.propertyType) &&
                isPropertyInFlanders(this.addressCountry, this.addressPostalCode)
            );
        },
        renderFloodSensitivity: function(): boolean {
            return isPropertyInFlanders(this.addressCountry, this.addressPostalCode);
        },
        floodZonesInfo: function(): string {
            const region = getFloodInfoRegion(this.addressCountry, this.addressPostalCode);
            const url = floodInfoLink(region);
            const key = region === "flanders"
                ? "everything_about_the_flood_zones_flanders"
                : "everything_about_the_flood_zones";
            return this.$t(key, { "url": url }) as string;
        },
    },

    mounted: function() {
        pushPageViewEvent("classified_deposit_step9_regulations_info");
    },

    methods: {
        ...mapActions({
            goToPreviousStep: "StepsWizard/previous",
            goToNextStep: "StepsWizard/next",
        }),
        clickNext: function() {
            this.isButtonDisabled = true;

            const completeStep = () => {
                Vue.nextTick(() => {
                    const errorInput = document.querySelector(".input--error") as HTMLElement;
                    if (errorInput) {
                        errorInput.focus();
                        window.scrollTo(0, 0);
                    }
                    this.isButtonDisabled = false;
                    this.goToNextStep();
                });
            };

            this.isEditionMode
                ? validationClassified(completeStep)
                : updateClassified(completeStep);
        },
        clickPrevious: function() {
            this.goToPreviousStep();
        },
    },
});

